<template>
  <div class="BoderWidth">
    <el-row class="contwidth">
      <el-col :span="24">
        <p>CÔNG TY CỔ PHẦN TRAVELLET VIỆT NAM</p>
        <p>Địa chỉ: 22 Hồng Hà, Phường 2, Quận Tân Bình, Thành phố Hồ Chí Minh</p>
        <p><a href="tel:0315819265">0315 81 92 65</a></p>
        <p>© Copyright 2018. All Rights Reserved.</p>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// import 'element-ui/lib/theme-chalk/display.css'
export default {
  name: 'foot',
  data () {
    return {
    }
  },
  methods: {
    FeetShowBtn () {
    }
  }
}
</script>

<style scoped>
.BoderWidth {
  position: relative;
  bottom: 0;
  z-index: 2000;
  width: 100%;
  /* height: 30px;
  line-height: 30px; */
  text-align: center;
  margin: 60px 0 0 0;
  padding: 20px 0;
  background: #fff;
}
.contwidth {
  width: 420px;
  margin: 0 auto;
  text-align: left;
  display: flex;
  justify-content: center;
}
.contwidth p {
  margin: 5px 0;
}
.FeetImgCont {
  display: flex;
  color: white;
}
.FeetImgCont img {
  width: 5.667rem;
  height: 5.667rem;
  border-radius: 1rem;
  margin-right: 2.5rem;
}
.FeetImgCont > ul > li {
  line-height: 1.9rem;
  white-space: nowrap;
}
.CloseBtn {
  text-align: right;
  color: white;
}
.close {
  cursor: pointer;
  color: white;
  border-radius: 1rem;
  line-height: 1.667rem;
  text-align: center;
  height: 1.667rem;
  width: 1.667rem;
  font-size: 2rem;
  padding: 0.083rem;
}
.close::before {
  content: "\2715";
}
.close {
  top: 0;
  right: 0;
  position: absolute;
}
.DownloadBtn {
  position: absolute;
  bottom: 0.25rem;
  right: 0;
}
.el-button {
  width: 8.333rem;
  height: 2.917rem;
  line-height: 2.917rem;
  padding: 0;
}
@media (max-width: 1200px) {
  .contwidth {
    width: 88%;
  }
}
@media (max-width: 992px) {
  .contwidth {
    width: 84%;
  }
}
@media (max-width: 768px) {
  .contwidth {
    width: 82%;
  }
}
@media (max-width: 576px) {
  .contwidth {
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/foot.vue